<template>
  <section>
    <comite-honor />
  </section>
</template>

<script>
import ComiteHonor from './ComiteHonor.vue'

export default {
  components: {
    ComiteHonor,
  },
}

</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
